<template>
  <v-card v-if="isLoading == false" class="planning-disponibilite" color="#C8E6C9">
    <v-dialog
      v-model="isModalsOpen['eventSavModal'].value"
      persistent
      align="center"
      width="100%"
      max-width="800px"
    >
      <modal-sav
        :data="isModalsOpen['eventSavModal'].data"
        :eventColorByType="eventColorByType"
        @closeModal="closeModal('eventSavModal')"
      ></modal-sav>
    </v-dialog>
    <v-dialog v-model="isModalsOpen['dateModal'].value" persistent>
      <modal-date
        :data="isModalsOpen['dateModal'].data"
        :eventColorByType="eventColorByType"
        @closeModal="closeModal('dateModal')"
      ></modal-date>
    </v-dialog>
    <v-dialog v-model="isModalsOpen['eventModal'].value" location="center" persistent>
      <modal-materiel-state
        @closeStatesModal="isModalsOpen['eventModal'].value = false"
        :data="isModalsOpen['eventModal'].data"
        @close="closeModal('eventModal')"
      >
      </modal-materiel-state>
      <!-- <modal-event
        :data="isModalsOpen['eventModal'].data"
        @closeModal="closeModal('eventModal')"
      ></modal-event> -->
    </v-dialog>
    <v-dialog v-model="isModalsOpen['settingsModal'].value" persistent>
      <modal-settings
        :eventColorByType="eventColorByType"
        :daysToHide="daysToHide"
        @closeSettingsModal="closeSettingsModal"
      ></modal-settings>
    </v-dialog>
    <v-dialog v-model="isDurationOptionsOpen" width="440" max-width="94%">
      <v-card class="pa-4">
        <div class="d-flex align-center mb-4">
          <v-icon class="mr-2" color="#5C6BC0">mdi-tune-variant</v-icon>
          <span style="font-weight: 700; font-size: 18px">Durées &amp; horaires</span>
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            variant="text"
            color="#EF5350"
            @click="isDurationOptionsOpen = false"
          ></v-btn>
        </div>
        <v-select
          label="Jours affichés"
          :items="nbrDaysdurationListe.map((e) => ({ title: e + ' j', value: e }))"
          v-model="selectedNbrDays"
          :disabled="calendarIsOpening"
          variant="outlined"
          density="comfortable"
          hide-details
          prepend-inner-icon="mdi-calendar-range"
          class="mb-3"
          :menu-props="{ maxHeight: 400 }"
        ></v-select>
        <v-select
          label="Durée créneau"
          :items="slotdurationListe"
          v-model="selectedslotduration"
          :disabled="calendarIsOpening"
          variant="outlined"
          density="comfortable"
          hide-details
          prepend-inner-icon="mdi-timer-sand"
          class="mb-3"
          :menu-props="{ maxHeight: 400 }"
        ></v-select>
        <v-select
          label="Heure de début"
          :items="startPlanningTime"
          v-model="selectedStartTime"
          :disabled="calendarIsOpening"
          variant="outlined"
          density="comfortable"
          hide-details
          prepend-inner-icon="mdi-clock-start"
          class="mb-3"
          :menu-props="{ maxHeight: 400 }"
        ></v-select>
        <v-select
          label="Heure de fin"
          :items="endPlanningTime"
          v-model="selectedEndTime"
          :disabled="calendarIsOpening"
          variant="outlined"
          density="comfortable"
          hide-details
          prepend-inner-icon="mdi-clock-end"
          :menu-props="{ maxHeight: 400 }"
        ></v-select>
      </v-card>
    </v-dialog>
    <div style="position: absolute; top: 112px; width: 100%; z-index: 0">
      <v-row class="ma-1" align="center">
        <v-col class="px-1">
          <v-card>
            <v-combobox
              :style="{ filter: calendarIsOpening ? 'blur(5px)' : '' }"
              :disabled="calendarIsOpening"
              clearable
              variant="solo"
              v-model="ressourceSelected"
              :items="[...new Set(getRessourceList)]"
              no-data-text="Aucune donnée pour cette recherche"
              label="Recherche"
              hide-details
              hide-selected
              multiple
              chips
              closable-chips
              style="background-color: white"
              :menu-props="{ maxHeight: 500 }"
            >
            </v-combobox>
          </v-card>
        </v-col>
        <v-col class="px-1">
          <v-card>
            <v-select
              label="Filtre d'affichage"
              :style="{ filter: calendarIsOpening ? 'blur(5px)' : '' }"
              :disabled="calendarIsOpening"
              variant="solo"
              v-model="selectedView"
              @update:modelValue="setSelectedView"
              :items="viewListe"
              hide-details
              style="background-color: white"
              :menu-props="{ maxHeight: 500 }"
            >
            </v-select>
          </v-card>
        </v-col>
        <v-col class="px-1" v-if="agencyListe.length > 2">
          <v-card>
            <v-select
              label="Agence"
              :style="{ filter: calendarIsOpening ? 'blur(5px)' : '' }"
              clearable
              :disabled="calendarIsOpening"
              variant="solo"
              @update:modelValue="setSelectedViewAgency"
              :items="agencyListe"
              item-title="ag_nom"
              return-object
              hide-details
              style="background-color: white"
              :menu-props="{ maxHeight: 500 }"
            >
            </v-select>
          </v-card>
        </v-col>
        <v-col class="px-1">
          <v-card>
            <v-btn
              block
              height="56"
              variant="flat"
              class="text-none"
              style="background-color: white; font-weight: 600; color: #37474f"
              :style="{ filter: calendarIsOpening ? 'blur(5px)' : '' }"
              :disabled="calendarIsOpening"
              @click="isDurationOptionsOpen = true"
            >
              <v-icon start size="22" color="#5C6BC0">mdi-tune-variant</v-icon>
              Durées &amp; horaires
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!-- {{ calendarOptions.events }} -->
    <!-- <FullCalendar :options="calendarOptions2" />  -->

    <full-calendar
      ref="calendarDispo"
      style="margin-top: 10px; margin-bottom: 10px"
      :style="{
        filter: calendarIsOpening ? 'blur(5px)' : '',
        height: windowSize.height - 80 + 'px',
      }"
      class="mx-2"
      :options="calendarOptions"
    >
    </full-calendar>
    <div
      v-if="calendarIsOpening == true"
      style="
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0px;
        background-color: rgb(0, 0, 0, 0.5);
        z-index: 3;
        padding-top: 40vh;
      "
      align="center"
    >
      <v-progress-circular size="120" indeterminate color="black"
        >Chargement</v-progress-circular
      >
    </div>
    <div
      ref="dispoLegend"
      :class="['dispo-legend', { 'is-hidden': legendHidden }]"
      style="position: absolute; bottom: 0px; right: 0px; z-index: 1"
    >
      <v-col>
        <v-row>
          <v-col
            style="
              background-color: #e0e0e0;
              border-style: none;
              padding: 5px;
              border-radius: 10px;
              box-shadow: 1px 1px 10px 2px grey;
            "
            v-if="eventColorState && Object.keys(eventColorState).length > 0"
            class="ml-2"
            cols="auto"
          >
            <button
              v-for="(value, key) in eventColorState"
              :key="key"
              :style="{ 'background-color': value.color }"
              style="
                font-size: 15px;
                margin: 5px;
                border: solid 1px grey;
                padding: 10px;
                border-style: none;
                border-radius: 5px;
                color: black;
              "
            >
              <v-chip
                style="background-color: rgb(0, 0, 0, 0.5); color: white; cursor: pointer"
              >
                {{ value.label }}
              </v-chip>
            </button>
          </v-col>
          <v-col
            v-else
            style="
              background-color: #e0e0e0;
              border-style: none;
              padding: 5px;
              border-radius: 10px;
              box-shadow: 1px 1px 10px 2px grey;
            "
            cols="auto"
          >
            <button
              v-for="(value, key) in eventColorByType"
              :key="key"
              :style="{ 'background-color': value.color }"
              style="
                font-size: 15px;
                margin: 5px;
                border: solid 1px grey;
                padding: 10px;
                border-style: none;
                border-radius: 5px;
                color: black;
              "
            >
              <v-chip
                style="background-color: rgb(0, 0, 0, 0.5); color: white; cursor: pointer"
              >
                {{ value.label }}
              </v-chip>
            </button>
          </v-col>
        </v-row>
      </v-col>
    </div>
  </v-card>
  <div
    v-else
    style="
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0px;
      background-color: rgb(0, 0, 0, 0.5);
      z-index: 3;
      padding-top: 40vh;
    "
    align="center"
  >
    <v-progress-circular size="120" indeterminate color="white"
      >Chargement</v-progress-circular
    >
  </div>
</template>

<script>
import mainEngine from "@/core/index";

import "@fullcalendar/core/vdom";
import FullCalendar from "@fullcalendar/vue3";
import calendarData from "../hooks/index";
import engine from "../core/index";
import modalDate from "@/projects/planning-disponibilite/components/modal-date.vue";
// import modalEvent from "@/projects/planning-disponibilite/components/modal-event.vue";
import ModalMaterielState from "@/components/modal-materiel-state.vue";
import modalSettings from "@/components/modal-planning-settings.vue";
import modalSav from "@/projects/planning-disponibilite/components/modal-sav.vue";
import { ref } from "@vue/reactivity";
import dayGridPlugin from "@fullcalendar/daygrid";

export default {
  props: {
    windowSize: {},
  },
  data() {
    return {
      engine: engine,
      ressourceSelected: [],
      isLoading: true,
      user: {},
      // Légende flottante : masquée quand le curseur est au-dessus (détection
      // via mousemove document pour éviter le clignotement du :hover CSS).
      legendHidden: false,
      // Fenêtre "Durées & horaires" (jours / créneau / début / fin).
      isDurationOptionsOpen: false,
    };
  },
  setup(props) {
    const calendarDispo = ref(null); // ✅ Ref pour le calendrier

    const calendarOptions2 = ref({
      plugins: [dayGridPlugin],
      initialView: "dayGridMonth",
      locale: "fr",
      headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,dayGridWeek",
      },
      events: [
        {
          title: "Réunion",
          date: "2026-02-05",
        },
        {
          title: "Démo client",
          start: "2026-02-15",
          end: "2026-02-17",
        },
      ],
      eventClick(info) {
        alert(`Événement : ${info.event.title}`);
      },
    });

    const {
      calendarOptions,
      resourceIds,
      setSubFamilyToShow,
      isModalsOpen,
      setModal,
      eventColorByType,
      updateCalendarColors,
      updateCalendarDaysToShow,
      daysToHide,
      isEventsLoaded,
      isMobile,
      calendarIsOpening,
      contratState,
      eventColorState,
      viewListe,
      selectedView,
      setSelectedView,
      nbrDaysdurationListe,
      slotdurationListe,
      startPlanningTime,
      endPlanningTime,
      selectedNbrDays,
      selectedslotduration,
      selectedStartTime,
      selectedEndTime,
      updatePlanningVue,
      agencyListe,
      setSelectedViewAgency,

      // setNewScreenSize
    } = calendarData(props.windowSize);

    const reloadCalendar = function () {
      console.log("reloadCalendar");

      if (calendarDispo.value) {
        const calendarApi = calendarDispo.value.getApi();
        calendarApi.refetchEvents();
        calendarApi.refetchResources();
      }
    };

    return {
      calendarOptions,
      resourceIds,
      setSubFamilyToShow,
      isModalsOpen,
      setModal,
      eventColorByType,
      updateCalendarColors,
      updateCalendarDaysToShow,
      daysToHide,
      isEventsLoaded,
      isMobile,
      calendarIsOpening,
      contratState,
      eventColorState,
      viewListe,
      selectedView,
      setSelectedView,
      nbrDaysdurationListe,
      slotdurationListe,
      startPlanningTime,
      endPlanningTime,
      selectedNbrDays,
      selectedslotduration,
      selectedStartTime,
      selectedEndTime,
      updatePlanningVue,
      agencyListe,
      setSelectedViewAgency,
      reloadCalendar,
      calendarOptions2,
      // setNewScreenSize
    };
  },
  mounted() {
    this.isMobile = this.$vuetify.display.mobile;
    this.setCalendarView();
    console.log("calendarOptions", this.calendarOptions);

    // this.onResize()
    // this.$nextTick(() => {
    //   window.addEventListener('resize', this.onResize);
    // })
    this.isUserConnected();
    document.addEventListener("mousemove", this.onLegendMouseMove);
  },
  beforeUnmount() {
    document.removeEventListener("mousemove", this.onLegendMouseMove);
  },
  methods: {
    // Masque la légende uniquement quand le curseur est réellement au-dessus
    // d'elle. On lit sa position via getBoundingClientRect (valable même à
    // opacity:0) : pas de dépendance au :hover, donc aucun clignotement.
    onLegendMouseMove(e) {
      const el = this.$refs.dispoLegend;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const inside =
        e.clientX >= r.left &&
        e.clientX <= r.right &&
        e.clientY >= r.top &&
        e.clientY <= r.bottom;
      if (inside !== this.legendHidden) {
        this.legendHidden = inside;
      }
    },
    setCalendarView() {
      // let that = this
      // let view = ""
      // if (this.$refs && this.$refs.calendarDispo) {
      //   if (this.isLittleScreen) {
      //     view = "mobile"
      //     this.fullView = false
      //   } else {
      //     view = "resourceTimeline7Day"
      //     this.fullView = true
      //   }
      //   let calendarApi = this.$refs.calendarDispo.getApi()
      //   calendarApi.changeView(view);
      // } else {
      //   setTimeout(function () {
      //     that.setCalendarView()
      //   }, 250)
      // }
    },
    // onResize() {
    // this.setNewScreenSize(window.innerWidth)
    // },
    closeSettingsModal(data) {
      let that = this;
      let days = data.daysListe.filter((val) => !data.daysToShow.includes(val.idx));
      if (days) {
        days = days.map((val) => val.idx);
        engine.save_day_to_hide(days.toString(), function () {
          that.updateCalendar();
        });
      }
      engine.save_calendar_colors(JSON.stringify(data.localColortab), function () {
        that.updateCalendar();
      });
      this.closeModal("settingsModal");
    },
    isUserConnected() {
      let that = this;
      let token = localStorage.getItem("userToken");
      mainEngine.get_user_by_token(token, function (data) {
        if (data.code != 0) {
          // localStorage.clear();
          localStorage.setItem("userToken", undefined);
        }
        that.isLoading = false;
      });
    },
    updateCalendar() {
      this.updateCalendarColors();
      this.updateCalendarDaysToShow();
    },
    closeModal(modalKey) {
      this.isModalsOpen[modalKey].value = false;
    },
  },
  watch: {
    isLittleScreen(val) {
      this.isMobile = val;
      this.setCalendarView();
    },
    // isMobileCmp(val) {
    //   this.isMobile = val;
    // },
    ressourceSelected(val) {
      if (val.length > 3) {
        this.ressourceSelected.pop();
      }
      this.setSubFamilyToShow(val);
    },
    selectedNbrDays() {
      this.updatePlanningVue();
    },
    selectedslotduration() {
      this.updatePlanningVue();
    },
    selectedStartTime() {
      this.updatePlanningVue();
    },
    selectedEndTime() {
      this.updatePlanningVue();
    },
  },
  computed: {
    isMobileCmp() {
      return this.$vuetify.display.mobile;
    },
    isLittleScreen() {
      return this.$vuetify.display.smAndDown;
    },
    getRessourceList() {
      let tabSubFamily = [...new Set(this.resourceIds.map((val) => val.subFamily))];
      let tabFamily = [...new Set(this.resourceIds.map((val) => val.family))];

      // return [...new Set(this.resourceIds.map((val) => val.subFamily))].sort();

      return tabSubFamily
        .concat(tabFamily)
        .sort()
        .filter((val) => val.length > 0);
    },
  },
  components: {
    FullCalendar,
    modalDate,
    // modalEvent,
    ModalMaterielState,
    modalSettings,
    modalSav,
  },
};
</script>

<style>
@import "../style.css";
</style>
